import { defineQuery } from 'next-sanity'
import { imageFields } from '../atoms'

export const splitCopyImageBlockFields = `
  _id,
  _type,
  title,
  heroImage,
  negativeMargin,
  image {
    ${imageFields}
  },
  titleAligned,
  body[]
`

export const SPLIT_COPY_IMAGE_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "split-copy-image-block"][0]{
    ${splitCopyImageBlockFields}
  }
`)
